import IPersona from "./persona.interface";

export class Persona implements IPersona {
    rut: number = 0;
    dv: string = '';
    nombres: string = '';
    paterno: string = '';
    materno: string = '';

    getRutConGuion() {
        return this.rut ? `${this.rut}-${this.dv}` : "";
    }

    getNombreCompleto() {
        return `${this.nombres} ${this.paterno} ${this.materno}`;
    }
}